import type { PagedResultDto } from "@services/dto/pagedResultDto"
import FeeTypeService from "@services/feeType/feeTypeService"
import { action, makeAutoObservable, observable } from "mobx"

class FeeTypeStore {
  @observable isLoading!: boolean
  @observable tableData!: PagedResultDto<any>
  @observable detailData!: any
  @observable feeVariableData!: any[]
  @observable listFeeType!: any[]
  constructor() {
    makeAutoObservable(this)

    this.tableData = { items: [], totalCount: 0 }

    this.feeVariableData = []
    this.listFeeType = []
  }

  @action
  async createOrUpdate(body: any) {
    this.isLoading = true
    const result = await FeeTypeService.createOrUpdate(body).finally(() => {
      this.isLoading = false
    })

    this.detailData = result
  }

  @action
  async get(id: number) {
    const result = await FeeTypeService.get(id)
    this.detailData = result
    return result
  }

  @action
  async getAll(params: any) {
    this.isLoading = true
    const result = await FeeTypeService.getAll(params).finally(
      () => (this.isLoading = false)
    )
    this.tableData = result
  }

  @action
  async getList(params: any) {
    this.isLoading = true
    const result = await FeeTypeService.getList(params).finally(
      () => (this.isLoading = false)
    )
    this.listFeeType = result
  }

  @action
  async activate(id: number, isActive) {
    await FeeTypeService.activateOrDeactivate(id, isActive)
  }

  @action
  async getAllFeeVariable(params?: any) {
    this.isLoading = true
    const result = await FeeTypeService.GetAll(params).finally(
      () => (this.isLoading = false)
    )
    this.feeVariableData = result
  }
}

export default FeeTypeStore
